<template>
  <div
    id="page-login"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <template #no-body>
          <div class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/logo/ubunbase_login.png"
                  alt="ubun base"
                  class="responsive"
                />
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8">
                  <h4 class="mb-4">
                    Ubun BASE ログイン
                  </h4>
                  ベンダー出品は<a :href="vendorUrl">こちら</a>
                  <ValidationForm
                    ref="loginObserver"
                    as="form"
                  >
                    <email-field
                      v-model="email"
                      class="mt-8"
                      rules="required|email"
                      full-width
                      @keydown.enter="onKeydownEnter"
                    />
                    <password-field
                      v-model="password"
                      class="mt-8"
                      rules="required|min:5|max:20"
                      full-width
                      @keydown.enter="onKeydownEnter"
                    />
                    <router-link
                      class="mt-2 block"
                      to="/password/forget"
                    >
                      パスワードを忘れた方
                    </router-link>
                    <single-submit-button
                      class="w-full my-8"
                      :onclick="onLoginClick"
                    >
                      ログイン
                    </single-submit-button>
                  </ValidationForm>
                  <hr />
                  <div>
                    <vs-button
                      class="w-full mt-8"
                      type="flat"
                      to="/register"
                    >
                      新規登録
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import EmailField from '@/components/fields/EmailField'
import PasswordField from '@/components/fields/PasswordField'
import SingleSubmitButton from '@/components/SingleSubmitButton'

export default {
  name: 'Login',
  components: {
    EmailField,
    PasswordField,
    SingleSubmitButton
  },
  data () {
    return {
      email: '',
      password: '',
      vendorUrl: `${process.env.VUE_APP_VENDOR_API_URL}/login`
    }
  },
  computed: {
    ...mapState('account', ['activeAccount']),
    ...mapState(['globalError', 'requestingStatus'])
  },
  watch: {
    globalError: {
      deep: true,
      handler ({ message }) {
        this.$vs.notify({
          position: 'top-center',
          color: 'danger',
          text: message,
          fixed: true
        })
      }
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    onKeydownEnter (event) {
      event.stopPropagation()
      event.preventDefault()
      // 日本語入力中のEnterキー操作は無効にする
      if (event.keyCode !== 13) return
      this.onLoginClick()
    },
    async onLoginClick () {
      const isValid = await this.$refs.loginObserver.validate()
      if (!isValid.valid) return
      try {
        const { email, password } = this
        await this.login({ email, password })
        if (!this.activeAccount.spApiOauthComplete) {
          await this.$router.push('/oauth')
        } else if (this.activeAccount.isNeedReauth) {
          await this.$router.push('/reoauth')
        } else {
          await this.$router.push('/')
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss"></style>
